import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Button } from 'antd';
import { requestListActions } from '../containers/Requests/request-list.actions'

class ShowOnMapComponent extends React.Component {
    
    handleCkick = () => {
        const { requests, selectedRequests } = this.props;
        const srequests = requests.filter(e=>selectedRequests.includes(e.id));
        this.props.dispatch(requestListActions.openMap(srequests))
    }

	render() {
		return ( !!this.props.selectedRequests.length &&
            <Tooltip title={'Показать на карте ('+ this.props.selectedRequests.length + ')'} placement="bottom">
            <Button type="primary" shape="circle" icon="environment" style={{ marginRight: '10px' }}
                disabled={!this.props.selectedRequests.length}
                onClick={this.handleCkick} />
            </Tooltip>)
	}
}

function mapStateToProps(state) {

    const { exportStore } = state;
    const { requests } = state.requestsStore;
    const { selectedRequests } = state.requestListStore;
	
	return { ...exportStore, requests, selectedRequests };
}

export default connect(mapStateToProps)(ShowOnMapComponent);